import { render, staticRenderFns } from "./SameDayLoans.vue?vue&type=template&id=219ed966&"
import script from "./SameDayLoans.vue?vue&type=script&lang=js&"
export * from "./SameDayLoans.vue?vue&type=script&lang=js&"
import style0 from "./SameDayLoans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports